import { render } from "./SocialsView.vue?vue&type=template&id=6e80a34e"
import script from "./SocialsView.vue?vue&type=script&lang=js"
export * from "./SocialsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__